module.exports = __webpack_public_path__ + "img/kia-Used.901de4cb.png";